module.exports = __webpack_public_path__ + "img/google-logo.6c635cdd.png";